import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {FormControl} from "@angular/forms";
import {dialogOpen} from "../../store/dialog/dialog.actions";
import {FolderSelectorDialogComponent} from "./folder-selector-dialog/folder-selector-dialog.component";
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {Observable, switchMap, withLatestFrom} from "rxjs";
import {filter, startWith, tap} from 'rxjs/operators';
import {selectFolderComponentObjects} from "../../store/savedReportsFolders/savedReportsFolders.selectors";
import {FolderComponentObject, FolderComponentObjects} from "../../classes/folder-component-object";

@Injectable()
export class FolderSelectorStore extends ComponentStore<any> {
  public control: FormControl;

  public readonly selected$: Observable<any> = this.select((state) => state.selected);
  public readonly path$: Observable<string> = this.select((state) => state.path);
  public readonly folderIdToMove$: Observable<number> = this.select((state) => state.folderIdToMove);

  private readonly _folderComponentObjects$: Observable<FolderComponentObjects> = this._store.select(selectFolderComponentObjects);
  private readonly _control = this.effect((params$: Observable<void>) => params$.pipe(
    switchMap(() => this.control.valueChanges.pipe(
      startWith(this.control.value),
      switchMap((folderId: number) => this._folderComponentObjects$.pipe(
        filter((folderComponentObjects: FolderComponentObjects): boolean => folderComponentObjects.length > 0),
        tap((folderComponentObjects: FolderComponentObjects): void => {
          const selected: FolderComponentObject = folderComponentObjects.find((folder: FolderComponentObject): boolean => folder.payload.id === folderId);

          this.patchState({
            selected: selected,
            path: selected.getFullPathToStr(),
            loaded: true
          });
        })
      ))
    ))
  ));

  private readonly _openDialog = this.effect((params$: Observable<void>) => params$.pipe(
    withLatestFrom(this.selected$, this.folderIdToMove$),
    tap(([_, selected, folderIdToMove]) => {
      this._store.dispatch(dialogOpen({
        component: FolderSelectorDialogComponent,
        disableClose: true,
        config: {
          width: '600px',
          height: 'auto',
          autoFocus: false
        },
        data: {
          folder: selected,
          control: this.control,
          folderIdToMove: folderIdToMove,
          viewType: 'list'
        }
      }));
    })
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      selected: null,
      path: '',
      loaded: false,
      folderIdToMove: null
    });
  }

  public initFolderId(folderIdToMove: number): void {
    this.patchState({
      folderIdToMove: folderIdToMove
    });
  }

  public initControl(control: FormControl): void {
    this.control = control;

    this._control();
  }

  public openFolderSelectorDialog(): void {
    this._openDialog();
  }
}
